export default function ArtistsPage() {
  return (
    <div className="max-w-4xl mx-auto mt-12 text-center text-gray-600">
      <h1 className="text-2xl font-bold mb-4">Artists</h1>
      <p>Coming Soon...</p>
    </div>
  );
}
